import { Http } from '../helpers'

export const ProjectService = {
  async search() {
    return await Http.get('/projects')
  },
  async all() {
    return await Http.get('/projects/all')
  },
  async allWithHome() {
    return await Http.get('/projects/all-with-home')
  },

  async view(id) {
    return await Http.get('/projects/' + id)
  },
  async getHomesByProject(id) {
    return await Http.get('/projects/' + id + '/homes')
  },
}
